export default {
  ROOT_ROUTE: '/',
  PAYMENT_LINK_ROUTE: '/payment/:paymentId',
  PAYMENT_LINK_NOT_FOUND_ROUTE: '/404',
}
